import { MemberStatus } from "@upsquad/shared";
import { Navigate } from "react-router";
import { AuthLayout } from "@/src/auth/components/auth-layout";
import { useLogout } from "@/src/auth/hooks/use-logout";
import { PageHelmet } from "@/src/common/components/page-helmet";
import { getSubdomain } from "@/src/common/lib/subdomain";
import { useGetMyMembershipBySlugQuery } from "@/src/community/services/community-http.service";
import { PendingApprovalModal } from "@/src/onboarding/components/modals/pending-approval-modal";

export default function PendingJoinCommunityPage() {
	const logout = useLogout();
	const subdomain = getSubdomain();
	const { data } = useGetMyMembershipBySlugQuery(subdomain ?? "", { skip: !subdomain });

	if (data?.status === MemberStatus.APPROVED) {
		return <Navigate to="/" replace />;
	}

	return (
		<>
			<PageHelmet title="Pending Approval" />
			<AuthLayout>
				<div />
			</AuthLayout>
			<PendingApprovalModal isOpen onSignOut={logout} />
		</>
	);
}
